import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonRow,
  IonText
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { DriverCardWeb } from "../driver-card/driverCard";
import { useDispatch } from "react-redux";
import { getPredecessorShipment } from "../../../actions/carrierAssign/action";
import { getPredecessorShipmentPayload } from "../../../pages/Execute/AssignDriverList/assignDriver.util";

import "./AssignDriverDialog.scss";
import { logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { useTranslation } from "react-i18next";
import { LIST_OF_DRIVERS } from "../../../utils/constants";

export interface IAssignDriverDialogProps {
  isOpen: boolean;
  onDismiss: (status: boolean) => void;
  loadDetails: any;
  driverList: any[];
  onIndexSelect: (index: number) => void;
  onSelectDriver: (driverDetails: any) => void;
  selectedIndex: number;
  shipmentId: string;
  history: any;
  driverDetails: any;
}

export const AssignDriverDialog: React.FunctionComponent<IAssignDriverDialogProps> = (
  props: IAssignDriverDialogProps
) => {
  const {
    isOpen = false,
    onDismiss,
    onIndexSelect,
    onSelectDriver,
    selectedIndex,
    history
  } = props;

  const [driverListState, setDriverListState] = useState<any>([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    if (!isOpen) {
      onSelectDriver({});
      onIndexSelect(-1);
    }
  }, [props.shipmentId]);

  useEffect(() => {
    setDriverListState(props.driverList);

    // Analytics implementation On Load assignment Screen
    logEvent(EVENT.SV_LOAD_ASSIGNMENT, {
      screen: SCREEN.ML_LOAD_ASSIGNMENT
    });

    logEvent(EVENT.UE_FILTER_USAGE, {
      screen: SCREEN.DA_DRIVER_FILTER
    });
  }, [props.driverList]);

  const searchDriver = (name: any) => {
    if (name === "") {
      setDriverListState(props.driverList);
      return;
    }
    const list = props.driverList.filter((item: any) =>
      `${item.firstName}${item.lastName}${item.mobileNumber}`
        .toLowerCase()
        .includes(name?.toLowerCase())
    );
    setDriverListState(list);
  };
  const driverassignDriverProps = {
    title: t("LIST_OF_DRIVERS") || LIST_OF_DRIVERS,
    contentAlignment: "left",
    size: "large",
    contentScroll: "deny",
    buttons: [
      {
        title: t("Cancel"),
        type: "secondary-cta-btn-web",
        onClick: () => {
          {
            onDismiss(true);
            onIndexSelect(-1);
          }
        }
      },
      {
        title: t("Assign"),
        type: "primary-cta-btn-web",
        isDisabled: !(selectedIndex > -1),
        onClick: () => {
          const actualStartDate =
          (props && props.loadDetails && props.loadDetails[0] &&
            (props.loadDetails[0].appointmentEarlyDateTime ||
              props.loadDetails[0].plannedArrivalDateTime));
              const payload = getPredecessorShipmentPayload({
                loadDetails: { shipmentId: props.shipmentId },
                driver: props.driverDetails
              });
              dispatch(getPredecessorShipment(payload));
              actualStartDate && onDismiss(false);
        }
      }
    ]
  };
  return (
    <React.Fragment>
      <CustomModalWeb isModalOpen={isOpen} {...driverassignDriverProps}>
        <div className="W-100 assign-driver-modal-content ion-padding">
          <IonRow >
            <IonCol size="8">
              <IonGrid className="search-field-grid">
                <IonRow>
                  <IonCol size="8" className="search-col">
                    <IonInput
                      className="search-input"
                      placeholder="Search by name or mobile"
                      onIonChange={e => searchDriver(e.detail.value)}
                    />
                  </IonCol>
                  <IonCol size="2" className="icon-col">
                    <IonIcon
                      className="search-icon"
                      src="assets/icon/search-group.svg"
                    ></IonIcon>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCol>
            <IonCol size="4">
              <IonButton
                className="secondary-cta-btn-web ion-float-right"
                onClick={() => {
                  onDismiss(true);
                  history.push({
                    pathname: "/app/userProfile/add",
                    state: {
                      addMode: true,
                      isAssignDriver: true,
                      module: history.location.pathname,
                      selectedShipmentId: props.shipmentId,
                      shipments:
                        history.location.state &&
                        history.location.state.shipments,
                      isGlobalSearch: history?.location?.state?.isGlobalSearch
                    }
                  });
                }}
              >
                Add Driver
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" className="driver-list" style={{ height: "500px" }}>
              <div className="list-box">
                {driverListState.map((driver: any, index: number) => {
                  return (
                    <DriverCardWeb
                      key={index}
                      driverData={driver}
                      index={index}
                      selectedIndex={selectedIndex}
                      onSelect={(selectedDriver: any, currentIndex: number) => {
                        onSelectDriver(selectedDriver);
                        onIndexSelect(currentIndex);
                      }}
                    />
                  );
                })}
                {driverListState.length === 0 && (
                  <IonText className="not-found-text">
                    No matches found, please modify your search
                  </IonText>
                )}
                <div className="list-end-banner ion-margin-bottom">
                    <div className="center">End of list</div>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </div>
      </CustomModalWeb>
    </React.Fragment>
  );
};
